import styled from 'styled-components';

export const TimelineWrapper = styled.div`
  height: calc(100% - 60px);
`;
